/* Approved homepage Studio samples. All state is local to this section. */
(() => {
  function initialize(scope) {
    scope
      .querySelectorAll(".bo-studio-stage:not([data-bo-ready])")
      .forEach((root) => {
        const copy = root.querySelector("[data-studio-copy]");
        if (!copy) return;
        const c = Object.fromEntries(
          [...copy.attributes]
            .filter((attribute) => attribute.name.startsWith("data-copy-"))
            .map((attribute) => [attribute.name.slice(10), attribute.value]),
        );
        const message = (key, values = {}) =>
          c[key].replace(/\{(\w+)\}/g, (token, name) =>
            Object.hasOwn(values, name) ? String(values[name]) : token,
          );
        const noun = (key, count) => c[key + (count === 1 ? "_one" : "_many")];
        const names = [...root.querySelectorAll("[data-destination]")].map(
          (card) => card.dataset.recipient,
        );
        const artworks = [...root.querySelectorAll(".ss-work")].map(
          (button) => ({
            name: button.querySelector("b").textContent,
            file: button.querySelector("img").dataset.art,
          }),
        );
        root.dataset.boReady = "true";
        const artSources = {};
        root.querySelectorAll("[data-art]").forEach((image) => {
          artSources[image.dataset.art] = image.src;
        });
        root.querySelectorAll("[data-insert]").forEach((button) => {
          artSources[button.dataset.insert] = button.dataset.src;
        });
        root.querySelectorAll("[data-scene]").forEach((panel) => {
          panel.hidden = panel.dataset.scene !== "brand";
        });

        (() => {
          root
            .querySelectorAll("[data-art]")
            .forEach((img) => (img.src = artSources[img.dataset.art]));
          const locations = {
            brand: c.brand_location,
            files: c.files_location,
            ship: c.ship_location,
          };
          root.querySelectorAll("[data-view]").forEach((button) =>
            button.addEventListener("click", () => {
              root
                .querySelectorAll("[data-view]")
                .forEach((b) =>
                  b.setAttribute("aria-selected", String(b === button)),
                );
              root
                .querySelectorAll("[data-scene]")
                .forEach(
                  (p) => (p.hidden = p.dataset.scene !== button.dataset.view),
                );
              root.querySelector('[data-ss="ss-location"]').textContent =
                locations[button.dataset.view];
            }),
          );
          root.querySelectorAll("[data-insert]").forEach((button) =>
            button.addEventListener("click", () => {
              root
                .querySelectorAll("[data-insert]")
                .forEach((b) =>
                  b.setAttribute("aria-pressed", String(b === button)),
                );
              const key = button.dataset.insert;
              root.querySelector('[data-ss="ss-insert-image"]').src =
                artSources[key];
              root.querySelector('[data-ss="ss-insert-image"]').alt =
                button.dataset.insertAlt;
              root.querySelector('[data-ss="ss-brand-selection"]').textContent =
                message("insert_message", { insert: button.textContent });
            }),
          );
          let selected = 0;
          root.querySelectorAll(".ss-work").forEach((button) =>
            button.addEventListener("click", () => {
              const active = button.getAttribute("aria-pressed") !== "true";
              button.setAttribute("aria-pressed", String(active));
              button.querySelector(".ss-check").textContent = active
                ? "✓"
                : "+";
              selected = root.querySelectorAll(
                '.ss-work[aria-pressed="true"]',
              ).length;
              root.querySelector('[data-ss="ss-count"]').textContent = message(
                "selected_message",
                { count: selected, works: noun("work", selected) },
              );
              root.querySelector('[data-ss="ss-run"]').textContent = message(
                "preview_button",
                { count: selected },
              );
              root.querySelector('[data-ss="ss-run"]').disabled =
                selected === 0;
              root.querySelector('[data-ss="ss-file-result"]').textContent =
                c.library_footer;
            }),
          );
        })();
        // Keyboard-accessible feature tabs; all benefit copy remains in the document.
        (() => {
          const group = root.querySelector(".ss-selectors");
          const buttons = [...root.querySelectorAll("[data-view]")];
          const panels = [...root.querySelectorAll("[data-scene]")];
          buttons.forEach((b) => {
            b.setAttribute("aria-selected", b.getAttribute("aria-pressed"));
            b.removeAttribute("aria-pressed");
          });
          group.setAttribute("role", "tablist");
          group.setAttribute("aria-label", c.invitation);
          function sync() {
            buttons.forEach((b, i) => {
              const active = b.getAttribute("aria-selected") === "true";
              b.setAttribute("aria-selected", String(active));
              if (active)
                root.style.setProperty("--ss-active-tab", String(i + 1));
              b.tabIndex = active ? 0 : -1;
            });
          }
          buttons.forEach((b, i) => {
            b.id = b.id || root.id + "-tab-" + i;
            b.setAttribute("role", "tab");
            const p = panels[i];
            p.id = p.id || root.id + "-panel-" + i;
            b.setAttribute("aria-controls", p.id);
            p.setAttribute("role", "tabpanel");
            p.setAttribute("aria-labelledby", b.id);
            b.addEventListener("click", sync);
            b.addEventListener("keydown", (e) => {
              let n;
              if (e.key === "ArrowRight") n = (i + 1) % buttons.length;
              if (e.key === "ArrowLeft")
                n = (i + buttons.length - 1) % buttons.length;
              if (e.key === "Home") n = 0;
              if (e.key === "End") n = buttons.length - 1;
              if (n === undefined) return;
              e.preventDefault();
              buttons[n].click();
              buttons[n].focus();
            });
          });
          sync();
        })();

        // A self-contained promotional print run; selections never leave this page.
        (() => {
          const library = root.querySelector('[data-ss="ss-library"]');
          const preview = root.querySelector('[data-ss="ss-run-preview"]');
          const review = root.querySelector('[data-ss="ss-run-review"]');
          const rows = root.querySelector('[data-ss="ss-run-rows"]');
          const settings = new Map();
          let works = [];
          function show(view, focus) {
            library.hidden = view !== "library";
            preview.hidden = view !== "preview";
            review.hidden = view !== "review";
            root.querySelector('[data-ss="ss-location"]').textContent =
              view === "library" ? c.files_location : c.run_location;
            root.querySelector(focus).focus({ preventScroll: true });
          }
          function totals() {
            const total = works.reduce(
              (sum, w) => sum + settings.get(w.key).quantity,
              0,
            );
            root.querySelector('[data-ss="ss-run-total"]').textContent = total;
            root.querySelector('[data-ss="ss-run-total-caption"]').textContent =
              message("total_caption", {
                prints: noun("print", total),
                count: works.length,
                works: noun("work", works.length),
              });
            return total;
          }
          root
            .querySelector('[data-ss="ss-run"]')
            .addEventListener("click", () => {
              works = [
                ...root.querySelectorAll('.ss-work[aria-pressed="true"]'),
              ].map((button) => ({
                key: button.querySelector("img").dataset.art,
                title: button.querySelector("b").textContent,
                src: button.querySelector("img").src,
              }));
              if (!works.length) return;
              rows.replaceChildren();
              works.forEach((work) => {
                if (!settings.has(work.key))
                  settings.set(work.key, { size: c.size_1, quantity: 2 });
              });
              works.forEach((work) => {
                const setting = settings.get(work.key);
                const row = document.createElement("div");
                row.className = "ss-run-row";
                const identity = document.createElement("div");
                identity.className = "ss-run-art";
                const img = document.createElement("img");
                img.src = work.src;
                img.alt = "";
                const title = document.createElement("b");
                title.textContent = work.title;
                identity.append(img, title);
                const label = document.createElement("label");
                label.className = "ss-size-control";
                const labelText = document.createElement("span");
                labelText.textContent = c.size_label;
                const select = document.createElement("select");
                select.setAttribute(
                  "aria-label",
                  work.title + " " + c.size_label,
                );
                [c.size_1, c.size_2, c.size_3].forEach((size) => {
                  const option = document.createElement("option");
                  option.value = size;
                  option.textContent = size + " " + c.size_unit;
                  select.append(option);
                });
                select.value = setting.size;
                select.addEventListener(
                  "change",
                  () => (setting.size = select.value),
                );
                label.append(labelText, select);
                const quantity = document.createElement("div");
                quantity.className = "ss-quantity";
                const minus = document.createElement("button");
                minus.type = "button";
                minus.textContent = "−";
                minus.setAttribute(
                  "aria-label",
                  message("fewer_label", { artwork: work.title }),
                );
                const count = document.createElement("output");
                count.setAttribute(
                  "aria-label",
                  work.title + " " + c.quantity_column,
                );
                count.setAttribute("aria-live", "polite");
                const plus = document.createElement("button");
                plus.type = "button";
                plus.textContent = "+";
                plus.setAttribute(
                  "aria-label",
                  message("more_label", { artwork: work.title }),
                );
                function update() {
                  count.textContent = setting.quantity;
                  minus.disabled = setting.quantity === 1;
                  plus.disabled = setting.quantity === 12;
                  totals();
                }
                minus.addEventListener("click", () => {
                  setting.quantity = Math.max(1, setting.quantity - 1);
                  update();
                });
                plus.addEventListener("click", () => {
                  setting.quantity = Math.min(12, setting.quantity + 1);
                  update();
                });
                quantity.append(minus, count, plus);
                update();
                const hint = document.createElement("span");
                hint.className = "ss-try-cue ss-sketch ss-row-cue";
                hint.setAttribute("aria-hidden", "true");
                hint.innerHTML =
                  '<span></span><svg viewBox="0 0 90 42" focusable="false"><path pathLength="100" d="M5 9 C12 30 49 40 80 22"/><path pathLength="100" d="M65 17 L81 21 L72 34"/></svg>';
                hint.querySelector("span").textContent = c.try_it;
                identity.append(hint);
                row.append(identity, label, quantity);
                rows.append(row);
              });
              totals();
              show("preview", '[data-ss="ss-run-title"]');
            });
          root
            .querySelector('[data-ss="ss-back-library"]')
            .addEventListener("click", () =>
              show("library", '[data-ss="ss-run"]'),
            );
          root
            .querySelector('[data-ss="ss-back-run"]')
            .addEventListener("click", () =>
              show("preview", '[data-ss="ss-review-run"]'),
            );
          root
            .querySelector('[data-ss="ss-review-run"]')
            .addEventListener("click", () => {
              const total = totals();
              root.querySelector('[data-ss="ss-review-stats"]').textContent =
                message("review_stats", {
                  worksCount: works.length,
                  works: noun("work", works.length),
                  printsCount: total,
                  prints: noun("print", total),
                });
              const lines = root.querySelector('[data-ss="ss-review-lines"]');
              lines.replaceChildren();
              works.forEach((work) => {
                const setting = settings.get(work.key);
                const line = document.createElement("div");
                line.className = "ss-review-line";
                const img = document.createElement("img");
                img.src = work.src;
                img.alt = "";
                const copy = document.createElement("div");
                const name = document.createElement("b");
                name.textContent = work.title;
                const detail = document.createElement("small");
                detail.textContent =
                  setting.size + " " + c.size_unit + " · " + c.paper_name;
                copy.append(name, detail);
                const qty = document.createElement("strong");
                qty.textContent =
                  setting.quantity + " " + noun("print", setting.quantity);
                line.append(img, copy, qty);
                lines.append(line);
              });
              show("review", '[data-ss="ss-review-title"]');
            });
          root
            .querySelector('[data-view="files"]')
            .addEventListener("click", () => {
              if (!preview.hidden || !review.hidden)
                root.querySelector('[data-ss="ss-location"]').textContent =
                  c.run_location;
            });
        })();

        // Move individual sample prints between recipients while preserving the order.
        (() => {
          let prints = [],
            selected = null;
          const splitButton = root.querySelector('[data-ss="ss-split-button"]');
          function render() {
            const chosen = prints.find((print) => print.id === selected);
            const shipments = new Set(prints.map((print) => print.destination))
              .size;
            root.querySelector(
              '[data-ss="ss-distribution-summary"]',
            ).textContent = message("shipment_summary", {
              count: shipments,
              shipments: noun("shipment", shipments),
            });
            root.querySelectorAll("[data-destination]").forEach((card) => {
              const destination = Number(card.dataset.destination);
              const items = prints.filter(
                (print) => print.destination === destination,
              );
              card.querySelector("[data-shipment-count]").textContent =
                items.length + " " + noun("print", items.length);
              const tiles = card.querySelector("[data-print-tiles]");
              tiles.replaceChildren();
              items.forEach((print) => {
                const art = artworks[print.art];
                const tile = document.createElement("button");
                tile.type = "button";
                tile.className = "ss-print-tile";
                tile.dataset.printId = print.id;
                tile.setAttribute(
                  "aria-label",
                  message("tile_aria", {
                    artwork: art.name,
                    number: print.id + 1,
                    recipient: names[destination],
                  }),
                );
                tile.setAttribute(
                  "aria-pressed",
                  String(selected === print.id),
                );
                const img = document.createElement("img");
                img.src = artSources[art.file];
                img.alt = "";
                tile.append(img);
                tile.addEventListener("click", () => {
                  selected = print.id;
                  render();
                  root.querySelector(
                    '[data-ss="ss-distribution-help"]',
                  ).textContent = message("selected_print", {
                    artwork: art.name,
                    recipient: names[destination],
                    button: c.move_button,
                  });
                  root
                    .querySelector('[data-print-id="' + print.id + '"]')
                    ?.focus({ preventScroll: true });
                });
                tiles.append(tile);
              });
              if (!items.length) {
                const empty = document.createElement("span");
                empty.className = "ss-empty-shipment";
                empty.textContent = c.empty_destination;
                tiles.append(empty);
              }
              const move = card.querySelector("[data-move-to]");
              move.disabled = !chosen || chosen.destination === destination;
              move.textContent =
                chosen && chosen.destination === destination
                  ? c.selected_here
                  : c.move_button;
              move.setAttribute(
                "aria-label",
                message("move_aria", { recipient: names[destination] }),
              );
              card.classList.toggle("ss-can-receive", !move.disabled);
              card.classList.toggle(
                "ss-print-source",
                Boolean(chosen && chosen.destination === destination),
              );
            });
          }
          root.querySelectorAll("[data-move-to]").forEach((button) =>
            button.addEventListener("click", () => {
              const chosen = prints.find((print) => print.id === selected);
              const to = Number(button.dataset.moveTo);
              if (!chosen || chosen.destination === to) return;
              const from = chosen.destination;
              chosen.destination = to;
              selected = null;
              render();
              root.querySelector(
                '[data-ss="ss-distribution-help"]',
              ).textContent = message("moved_print", {
                artwork: artworks[chosen.art].name,
                from: names[from],
                to: names[to],
              });
              const moved = root.querySelector(
                '[data-print-id="' + chosen.id + '"]',
              );
              moved?.focus({ preventScroll: true });
            }),
          );
          splitButton.addEventListener("click", () => {
            const split = splitButton.getAttribute("aria-pressed") !== "true";
            splitButton.setAttribute("aria-pressed", String(split));
            root.querySelector('[data-ss="ss-split"]').hidden = !split;
            root.querySelector('[data-ss="ss-unsplit"]').hidden = split;
            splitButton.textContent = split ? c.reset_button : c.split_button;
            root.querySelector('[data-ss="ss-shipping-status"]').textContent =
              split ? c.ship_disclaimer : c.before_split;
            if (split) {
              prints = Array.from({ length: 12 }, (_, id) => ({
                id,
                art: id % 3,
                destination: id < 4 ? 0 : id === 4 ? 1 : 2,
              }));
              selected = 0;
              render();
              root.querySelector(
                '[data-ss="ss-distribution-help"]',
              ).textContent = message("split_help", {
                artwork: artworks[0].name,
                recipient: names[0],
                other: names[1],
                studio: names[2],
              });
            }
          });
        })();
      });
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", () => initialize(document), {
      once: true,
    });
  else initialize(document);
  document.addEventListener("shopify:section:load", (event) =>
    initialize(event.target),
  );
  document.addEventListener("shopify:block:select", (event) => {
    const panel = event.target.closest("[data-scene]");
    const root = panel?.closest(".bo-studio-stage");
    if (!root) return;
    root.querySelector('[data-view="' + panel.dataset.scene + '"]')?.click();
    // Selecting print-run content always reveals its library entry point.
    if (panel.dataset.scene === "files") {
      root.querySelector('[data-ss="ss-library"]').hidden = false;
      root.querySelector('[data-ss="ss-run-preview"]').hidden = true;
      root.querySelector('[data-ss="ss-run-review"]').hidden = true;
      root.querySelector('[data-ss="ss-location"]').textContent = root
        .querySelector("[data-studio-copy]")
        .getAttribute("data-copy-files_location");
    }
  });
})();
